(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  (function () {
    function updateBannerScrollbar(slider) {
      var bar = slider.querySelector('.collection-banner-list__scrollbar');
      var thumb = slider.querySelector('.collection-banner-list__scrollbar-thumb');
      if (!bar || !thumb) return;

      var maxScroll = slider.scrollWidth - slider.clientWidth;
      if (maxScroll <= 1) {
        bar.hidden = true;
        return;
      }

      bar.hidden = false;
      var trackWidth = bar.clientWidth;
      var thumbWidth = Math.max(32, (slider.clientWidth / slider.scrollWidth) * trackWidth);
      var maxThumbX = Math.max(0, trackWidth - thumbWidth);
      var x = maxThumbX === 0 ? 0 : (slider.scrollLeft / maxScroll) * maxThumbX;
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + x + 'px)';
    }

    function initBannerScrollbars(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.collection-banner-list__slider--scroll').forEach(function (slider) {
        updateBannerScrollbar(slider);
        if (slider.dataset.scrollbarReady === 'true') return;
        slider.dataset.scrollbarReady = 'true';

        var bar = slider.querySelector('.collection-banner-list__scrollbar');
        var thumb = slider.querySelector('.collection-banner-list__scrollbar-thumb');
        if (!bar || !thumb) return;

        slider.addEventListener('scroll', function () {
          updateBannerScrollbar(slider);
        }, { passive: true });

        if (window.ResizeObserver) {
          var observer = new ResizeObserver(function () {
            updateBannerScrollbar(slider);
          });
          observer.observe(slider);
          var track = slider.querySelector('.collection-banner-list__track');
          if (track) observer.observe(track);
        }

        var dragging = false;
        var startX = 0;
        var startScroll = 0;

        thumb.addEventListener('pointerdown', function (event) {
          dragging = true;
          startX = event.clientX;
          startScroll = slider.scrollLeft;
          bar.classList.add('is-dragging');
          thumb.setPointerCapture(event.pointerId);
          event.preventDefault();
        });

        thumb.addEventListener('pointermove', function (event) {
          if (!dragging) return;
          var maxScroll = slider.scrollWidth - slider.clientWidth;
          var maxThumbX = bar.clientWidth - thumb.offsetWidth;
          if (maxScroll <= 0 || maxThumbX <= 0) return;
          slider.scrollLeft = startScroll + ((event.clientX - startX) / maxThumbX) * maxScroll;
        });

        function endDrag() {
          dragging = false;
          bar.classList.remove('is-dragging');
        }

        thumb.addEventListener('pointerup', endDrag);
        thumb.addEventListener('pointercancel', endDrag);

        bar.addEventListener('pointerdown', function (event) {
          if (event.target === thumb) return;
          var maxScroll = slider.scrollWidth - slider.clientWidth;
          var maxThumbX = bar.clientWidth - thumb.offsetWidth;
          if (maxScroll <= 0 || maxThumbX <= 0) return;
          var clickX = event.clientX - bar.getBoundingClientRect().left - thumb.offsetWidth / 2;
          var targetX = Math.min(Math.max(clickX, 0), maxThumbX);
          slider.scrollLeft = (targetX / maxThumbX) * maxScroll;
        });
      });
    }

    initBannerScrollbars(document);

    document.addEventListener('shopify:section:load', function (event) {
      initBannerScrollbars(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-chart"]) return;
  try {
    
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('.sizechart__sublabel-text, [data-size-unit]');
    if (!toggle) return;
    if (toggle.closest('.js-size-chart, .product-size-guide-drawer')) return;
    var container = toggle.closest('.size-chart-container');
    if (!container) return;
    var isCm = /cm|centimeter/i.test((toggle.getAttribute('data-size-unit') || '') + ' ' + (toggle.textContent || ''));
    container.querySelectorAll('.sizechart__sublabel-text').forEach(function(sib){
      sib.classList.toggle('sizechart__sublabel--active', sib === toggle);
    });
    container.setAttribute('data-size-unit-active', isCm ? 'centimeters' : 'inches');
    container.querySelectorAll('tr.inches').forEach(function(row){
      row.style.setProperty('display', isCm ? 'none' : 'table-row', 'important');
    });
    container.querySelectorAll('tr.centimeters').forEach(function(row){
      row.style.setProperty('display', isCm ? 'table-row' : 'none', 'important');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
